<div
  *ngIf="this.router.url === '/multi-cert'"
  class="ic1-row ic1-pt-24 ic1-pb-4">
  <div
    class="welcome ic1-col-12 ic1-mb-12"
    [HTMLTranslate]="'MULTI_CERT_PAGE.WELCOME'"></div>
</div>

<button
  *ngIf="this.isMulticert && this.router.url !== '/multi-cert'"
  type="button"
  class="back-to ic1-row ic1-pt-24 ic1-pl-20"
  (click)="go('/multi-cert')">
  <img src="assets/images/blue-arrow-back.svg" alt="" aria-hidden="true" />
  <span class="ic1-pl-4" [HTMLTranslate]="'MULTI_CERT_PAGE.BACK_TO_LIST'"></span>
</button>

<section
  *ngIf="this.router.url !== '/multi-cert'"
  class="ic1-row ic1-pt-24 ic1-pb-4"
  [attr.aria-label]="'USER_DETAILS_PAGE.SECTION_LABEL' | translate">
  <div
    class="ic1-col-12 ic1-col-lg-7"
    role="region"
    aria-labelledby="profile-card-label">
    <span
      id="profile-card-label"
      class="sr-only"
      >{{ primaryCard?.title
      }}<ng-container *ngIf="primaryCard?.spidType"
        >&nbsp;{{ primaryCard?.spidType }}</ng-container
      ></span
    >
    <div class="profile-tooltip-container">
      <ng-ui-kit-selfcare-profiles
        [primaryCard]="primaryCard"
        [profiles]="profiles">
      </ng-ui-kit-selfcare-profiles>
      <!-- TOOLTIP CUSTOM ICON -->
      <ng-ui-kit-tooltip
        *ngIf="
          (userSession$ | async)?.icssUser ||
          (userSession$ | async)?.trissUser
        "
        class="tooltipInfoEmail"
        [icId]="'ic1-tooltip-long'"
        [color]="'info'"
        [ariaLabel]="'USER_DETAILS_PAGE.TOOLTIP_MESSAGE' | translate">
        <div [innerHTML]="'USER_DETAILS_PAGE.TOOLTIP_MESSAGE' | translate"></div>
      </ng-ui-kit-tooltip>
    </div>
  </div>

  <div class="ic1-col-12 ic1-col-lg-5">
    <div
      class="notification-container ic1-flex-column ic1-flex-lg-row noIconInfo">
      <a
        routerLink="/actionReport"
        [queryParams]="{ date: '1-week' }"
        routerLinkActive="active"
        *ngIf="
          weeklySigns >= 1 &&
          !(userSession$ | async)?.automatic &&
          !(userSession$ | async)?.eseal
        ">
        <ng-ui-kit-card
          *ngIf="
            (userSession$ | async)?.icssUser ||
            (userSession$ | async)?.trissUser
          "
          type="status"
          [hasLongTitle]="true"
          [title]="($signsCounter | async)?.weeklySigns + '' || '0'"
          [text]="'COMMON.WEEKLY_SIGNS' | translate"
          [attr.translate-key]="'COMMON.WEEKLY_SIGNS'"
          status="info">
        </ng-ui-kit-card>
      </a>
      <a
        routerLink="/actionReport"
        routerLinkActive="active"
        *ngIf="
          totalSigns >= 1 &&
          !(userSession$ | async)?.automatic &&
          !(userSession$ | async)?.eseal
        ">
        <ng-ui-kit-card
          *ngIf="
            (userSession$ | async)?.icssUser ||
            (userSession$ | async)?.trissUser
          "
          type="status"
          [hasLongTitle]="true"
          [title]="($signsCounter | async)?.totalSigns + '' || '0'"
          [text]="'COMMON.TOTAL_SIGNS' | translate"
          [attr.translate-key]="'COMMON.TOTAL_SIGNS'"
          status="info">
        </ng-ui-kit-card>
      </a>
    </div>
  </div>
</section>

<!--<div class="user-info-section">



 <div class="signs-container pc" *ngIf="isIcssUser">
    <div
      class="sign-card success"
      routerLink="/actionReport"
      routerLinkActive="active">
      <div class="line">
        {{ weeklySigns }}
        <img class="user-details-icon" src="assets/images/success-icon.svg" />
      </div>
      <div class="desc" translate>COMMON.WEEKLY_SIGNS</div>
    </div>
    <div class="sign-card info">
      <div class="line">
        {{ totalSigns }}
        <img class="user-details-icon" src="assets/images/info-icon.svg" />
      </div>
      <div class="desc" translate>COMMON.TOTAL_SIGNS</div>
    </div>
  </div>
</div>-->
<hr class="section-line" aria-hidden="true" />
<!-- <div class="signs-container mobile" *ngIf="isIcssUser">
  <div class="sign-card info">
    {{ totalSigns }}
    <div class="desc" translate>COMMON.TOTAL_SIGNS</div>
    <img class="mobile-icon" src="assets/images/info-icon.svg" />
  </div>
  <div
    class="sign-card success"
    routerLink="/actionReport"
    routerLinkActive="active">
    {{ weeklySigns }}
    <div class="desc" translate>COMMON.WEEKLY_SIGNS</div>
    <img class="mobile-icon" src="assets/images/success-icon.svg" />
  </div>
</div> -->
